"use client";

import { useWindowSizeStore } from "@erp/shared-libs/stores";
import { useEffect } from "react";

export const WindowSizeProvider = () => {
  const { setWidth, setHeight } = useWindowSizeStore();

  // =================================================
  // 自動取得 100 高度，在螢幕方向或視窗尺寸改變時重新設定
  // =================================================
  useEffect(() => {
    const abortController = new AbortController();

    function setVh() {
      // 取得當前視窗高度的 1%
      const vh = window.innerHeight * 0.01;
      // 設定到 :root
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    // 初次執行
    setVh();

    window.addEventListener("resize", setVh, { signal: abortController.signal });
    window.addEventListener("orientationchange", setVh, { signal: abortController.signal });

    // 行動裝置視窗（鍵盤開關）
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", setVh, {
        signal: abortController.signal,
      });
    }

    return () => {
      abortController.abort();
    };
  }, []);

  // =================================================
  // 監聽視窗大小變化
  // =================================================
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize, { passive: true });

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWidth, setHeight]);

  return null;
};
